import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faBookOpen, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { 
    CourseCardContainer, 
    CourseImageSection, 
    CourseContent, 
    CourseTitle, 
    CourseStatsText, 
    CourseStatsRow, 
    StatsGroup,
    StatPill,
    PricePill,
    StartButton 
} from './styled';

const CourseCardComponent = ({ item, theme }) => {
    const handleCourseClick = () => {
        // Navigate to course checkout page using the checkoutUrl from the backend
        const courseUrl = item.checkoutUrl;
        
        if (!courseUrl) {
            console.warn('CourseCardComponent - No checkoutUrl available for course:', item);
            return;
        }
        
        console.log('CourseCardComponent - Navigating to:', courseUrl);
        window.location.href = courseUrl;
    };

    // Parse course data if it's stored as JSON string
    let courseData = {};
    try {
        if (typeof item.courseData === 'string' && item.courseData.trim()) {
            courseData = JSON.parse(item.courseData);
        } else if (typeof item.courseData === 'object' && item.courseData !== null) {
            courseData = item.courseData;
        }
        // Check if course data is in a different field
        else if (item.course) {
            courseData = item.course;
        }
    } catch (error) {
        console.error('CourseCardComponent - Error parsing courseData:', error);
        courseData = {};
    }

    // Use pre-calculated counts from backend, fallback to manual calculation
    const moduleCount = courseData.moduleCount || 
        (courseData.modules ? courseData.modules.length : 0);
    
    const totalLessons = courseData.lessonCount || 
        (courseData.modules ? courseData.modules.reduce((total, module) => {
            const lessonCount = module.lessons ? module.lessons.length : 0;
            return total + lessonCount;
        }, 0) : 0);
    
    // Try different properties for thumbnail image
    const thumbnailImage = item.thumbnail || item.image || item.featuredImage || item.checkoutImage || 
                          (item.courseData && typeof item.courseData === 'object' && item.courseData.thumbnail) ||
                          (item.courseData && typeof item.courseData === 'string' && JSON.parse(item.courseData).thumbnail);

    // Format price for display
    const formatPrice = (price) => {
        if (!price) return null;
        const numPrice = parseFloat(price);
        if (isNaN(numPrice)) return null;
        return numPrice === 0 ? 'Free' : `$${numPrice.toFixed(2)}`;
    };

    const displayPrice = formatPrice(item.price);

    return (
        <CourseCardContainer theme={theme} onClick={handleCourseClick}>
            <CourseImageSection theme={theme}>
                {thumbnailImage ? (
                    <>
                        <img 
                            src={thumbnailImage} 
                            alt={item.text || item.title || 'Course'} 
                            className="course-thumbnail"
                        />
                        <div className="image-overlay" />
                        <CourseTitle theme={theme}>
                            {item.text || item.title || 'Untitled Course'}
                        </CourseTitle>
                    </>
                ) : (
                    <>
                        <div className="course-hero-bg">
                            <div className="gradient-overlay"></div>
                            <div className="course-icon">
                                <FontAwesomeIcon icon={faPlay} />
                            </div>
                        </div>
                        <CourseTitle theme={theme}>
                            {item.text || item.title || 'Untitled Course'}
                        </CourseTitle>
                    </>
                )}
            </CourseImageSection>
            
            <CourseContent>
                {/* Modern stats display with pills */}
                {(moduleCount > 0 || totalLessons > 0) ? (
                    <CourseStatsRow>
                        <StatsGroup>
                            <StatPill theme={theme}>
                                <FontAwesomeIcon icon={faBookOpen} />
                                {moduleCount} Module{moduleCount !== 1 ? 's' : ''}
                            </StatPill>
                            <StatPill theme={theme}>
                                <FontAwesomeIcon icon={faGraduationCap} />
                                {totalLessons} Lesson{totalLessons !== 1 ? 's' : ''}
                            </StatPill>
                        </StatsGroup>
                        {displayPrice && (
                            <PricePill theme={theme}>
                                {displayPrice}
                            </PricePill>
                        )}
                    </CourseStatsRow>
                ) : (
                    <CourseStatsRow>
                        <CourseStatsText theme={theme}>
                            Course content available
                        </CourseStatsText>
                        {displayPrice && (
                            <PricePill theme={theme}>
                                {displayPrice}
                            </PricePill>
                        )}
                    </CourseStatsRow>
                )}
                
                <StartButton 
                    onClick={(e) => {
                        e.stopPropagation();
                        handleCourseClick();
                    }}
                    theme={theme}
                >
                    Start Journey
                </StartButton>
            </CourseContent>
        </CourseCardContainer>
    );
};

export default CourseCardComponent;
